import { useActiveImpersonation } from '../hooks/use-active-impersonation'

export function ImpersonationBootstrap() {
  useActiveImpersonation()
  return null
}
